import ky from 'ky';
import Config from './config';
import type { IndexesData } from './database/lib/IndexUtil';
import type { PicoConfigData } from './pico/lib/PicoUtils';

/**
 * Data converted from the original XOOPS modules. It is served with the rest of
 * static-contents/ rather than bundled, so it is fetched once at start up and
 * handed to the singletons before the app renders.
 */
export interface SiteData {
    tree: IndexesData;
    pico: PicoConfigData[];
}

// ky hands the URL to fetch()/Request, which rejects bare relative paths.
const resolve = (path: string): string => new URL(Config.BASE_URL + path, window.location.href).toString();

export const loadSiteData = async (): Promise<SiteData> => {
    const [tree, pico] = await Promise.all([
        ky.get(resolve('/modules/xoonips/tree.json')).json<IndexesData>(),
        // Each pico module keeps its own index next to its pages.
        Promise.all(
            Config.PICO_MODULES.map((name) => ky.get(resolve(`/modules/${name}/config.json`)).json<PicoConfigData>())
        ),
    ]);
    return { tree, pico };
};
